import Rest from '../Rest'

export default class StudentRevenueService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/student_revenue'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }
}
